// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 2107 ? "vendor.prosemirror-tables" : chunkId) + "." + {"2107":"1d84014121b3ec0953ad","6980":"d84e8a53890b5d374fd0"}[chunkId] + ".js";
};